<app-popover *ngIf="singleBookingDetails" (closeCallback)="handleCloseBookingDetails()" size="full">
  <div popover-header>
    <div class="booking-details-header">
      BOOKING ID {{singleBookingDetails.bookingId}}
    </div>
  </div>
  <div popover-content>
    <app-requester-details [requester]="singleBookingDetails.requester" [paymentType]="singleBookingDetails.paymentType"></app-requester-details>
    <app-payee-details *ngIf = "singleBookingDetails.paymentType === 'Bill To User' && singleBookingDetails.payer"
    [payee]="singleBookingDetails.payer" [paymentType]="singleBookingDetails.paymentType">
    </app-payee-details>  
    <app-booking-details [booking]="singleBookingDetails"></app-booking-details>
  </div>
</app-popover>